// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import SettingsEtc from 'components/settings/SettingsEtc';
import QuestionModal from 'components/common/QuestionModal/QuestionModal';
import { SettingsActions } from 'store/actionCreators';
import { type ContextRouter, withRouter } from 'react-router-dom';
import storage from 'lib/storage';
import { logout as ssoLogout } from 'lib/sso';

type Props = {
  askUnregister: boolean,
  unregisterToken: ?string,
} & ContextRouter;

class SettingsEtcContainer extends Component<Props> {
  onConfirmUnregister = async () => {
    try {
      await SettingsActions.generateUnregisterToken();
      const { unregisterToken } = this.props;
      if (!unregisterToken) return;
      await SettingsActions.unregister(unregisterToken);
      await storage.clear();
      await sessionStorage.clear();
      await ssoLogout();
    } catch (e) {
      console.log(e);
    }
  };
  onAskUnregister = () => {
    SettingsActions.askUnregister(true);
  };
  onCancelUnregister = () => {
    SettingsActions.askUnregister(false);
  };

  render() {
    const { askUnregister } = this.props;
    return (
      <Fragment>
        <SettingsEtc onAskUnregister={this.onAskUnregister} />
        <QuestionModal
          title="탈퇴하기"
          description="정말로 회원탈퇴를 하시겠습니까? 주문내역은 초기화되며 복구가 불가능합니다."
          onCancel={this.onCancelUnregister}
          onConfirm={this.onConfirmUnregister}
          open={askUnregister}
          confirmText="탈퇴"
        />
      </Fragment>
    );
  }
}

export default connect(
  ({ settings, auth }: State) => ({
    askUnregister: settings.askUnregister,
    unregisterToken: settings.unregisterToken,
  }),
  () => ({}),
)(withRouter(SettingsEtcContainer));



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsEtcContainer.js